import ReusableTable from "../../../../../components/common/table/Table";
import { inRepairRoDetailPnColumnData } from "../../../../../data/table-data/inRepairRoDetailPnTableData";
import { RO_DETAIL_COLORS } from "../../data/inRepairRoDetailConstants";
import RoDetailCard from "./RoDetailCard";
import RoDetailSectionLabel from "./RoDetailSectionLabel";
import {
  roDetailPnTableBodyCellStyle,
  roDetailPnTableContainerStyle,
  roDetailPnTableHeaderCellStyle,
  roDetailPnTableNoRecordStyle,
  roDetailPnTableRowCellStyle,
} from "./roDetailPnTableStyles";

const RoDetailPartsTable = ({ rows = [], sx }) => (
  <RoDetailCard sx={sx}>
    <RoDetailSectionLabel>All Parts in this RO</RoDetailSectionLabel>
    <ReusableTable
      columns={inRepairRoDetailPnColumnData}
      data={rows}
      pagination={false}
      enableSorting={false}
      lastColumnEnd={false}
      maxHeight="280px"
      customBoxStyles={{ p: 0, mb: 0 }}
      customTableStyles={roDetailPnTableContainerStyle}
      customHeaderCellStyle={roDetailPnTableHeaderCellStyle}
      customCellStyle={roDetailPnTableRowCellStyle}
      customTableCellStyle={() => roDetailPnTableBodyCellStyle}
      norecordStyle={roDetailPnTableNoRecordStyle}
      tableStyle={{
        "& .MuiTableRow-root": {
          backgroundColor: `${RO_DETAIL_COLORS.cardBg} !important`,
          "&:hover": {
            backgroundColor: `${RO_DETAIL_COLORS.cardBg} !important`,
          },
          "&:hover td": {
            backgroundColor: `${RO_DETAIL_COLORS.cardBg} !important`,
          },
        },
        "& .MuiTableHead-root .MuiTableRow-root": {
          backgroundColor: `${RO_DETAIL_COLORS.cardBg} !important`,
        },
      }}
    />
  </RoDetailCard>
);

export default RoDetailPartsTable;
